import { useState, useEffect } from 'react'
import api from '../../services/api'
import ErrorMessage from '../../components/common/ErrorMessage'
import Loading from '../../components/common/Loading'
import SettingsForm from './components/SettingsForm'
import './Settings.css'

export interface Settings {
  candidate_name: string
  responsable_publication: string
  slogan: string
  contact_email: string
  social_facebook: string
  social_twitter: string
  social_instagram: string
  social_linkedin: string
  primary_color: string
  secondary_color: string
  site_logo: string
  site_favicon: string
}

function Settings() {
  const [settings, setSettings] = useState<Settings | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')

  useEffect(() => {
    loadSettings()
  }, [])

  const loadSettings = async () => {
    try {
      setLoading(true)
      setError('')
      const data = await api.get<Settings>('/settings')
      setSettings(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement')
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (formData: Settings) => {
    try {
      setSaving(true)
      setError('')
      setSuccessMessage('')
      await api.put('/settings', formData)
      setSettings(formData)
      setSuccessMessage('Paramètres sauvegardés avec succès')
      // Clear success message after 3 seconds
      setTimeout(() => setSuccessMessage(''), 3000)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors de la sauvegarde')
    } finally {
      setSaving(false)
    }
  }

  if (loading) {
    return <Loading />
  }

  if (!settings) {
    return (
      <div className="admin-content">
        <ErrorMessage message="Impossible de charger les paramètres" />
      </div>
    )
  }

  return (
    <div className="settings-management">
      <div className="settings-header">
        <h1>Paramètres du site</h1>
        <p className="settings-subtitle">
          Configurez les informations globales de votre campagne
        </p>
      </div>

      {error && <ErrorMessage message={error} />}

      {successMessage && (
        <div className="success-message">
          <span className="success-icon">✓</span>
          <span>{successMessage}</span>
        </div>
      )}

      <SettingsForm
        initialData={settings}
        onSubmit={handleSubmit}
        saving={saving}
      />
    </div>
  )
}

export default Settings
